// extracted by mini-css-extract-plugin
export var button = "download-block-module--button--XRpRB";
export var link = "download-block-module--link--0pdAS";
export var nameWrapper = "download-block-module--name-wrapper--0xvnX";
export var wrapper = "download-block-module--wrapper----15T";